// PatientDetailsTab.jsx
import React, {
  useState,
  useCallback,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faInfoCircle,
  faUserTie,
  faBirthdayCake,
  faVenusMars,
  faBuilding,
  faFileAlt,
  faShieldAlt,
  faBed,
  faMoneyBillWave,
  faStethoscope,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import MemberViewModal from "../Member/MemberViewModal";

const PatientDetailsTab = ({
  register,
  errors,
  vipChecked,
  setVipChecked,
  details,
}) => {
  
    const [selectedMemberId, setSelectedMemberId] = useState(null);
    const [isViewMemberModalOpen, setIsViewMemberModalOpen] = useState(false);

    const handleViewMemberInfo = useCallback(() => {
        if (details?.transaction?.member_id) {
          setSelectedMemberId(details?.transaction?.member_id);
          setIsViewMemberModalOpen(true);
        }
      }, [details?.transaction?.member_id]);

    const handleViewPrincipalInfo = useCallback(() => {
        if (details?.member?.principal_id) {
          setSelectedMemberId(details?.member?.principal_id);
          setIsViewMemberModalOpen(true);
        }
      }, [details?.member?.principal_id]);

  // console.log(details);
  // HELPER FUNCTIONS
  // Function to get meaning based on plan type
  const getPlanTypeMeaning = (type) => {
    switch (type?.toUpperCase()) {
      case "P":
        return "Principal";
      case "D":
        return "Dependent";
      case "B":
        return "Both (Principal/Dependent)";
      default:
        return "N/A";
    }
  };


  // Plan Limit Type
  const getPlanLimitTypeMeaning = (type) => {
    switch (type) {
      case 1:
        return "MBL Only (Maximum Benefit Limit)";
      case 2:
        return "ABL Only (Annual Benefit Limit)";
      case 3:
        return "Both MBL & ABL";
      default:
        return "N/A";
    }
  };

  // Function to get meaning based on member type
  const getMemberTypeMeaning = (type) => {
    switch (type?.toUpperCase()) {
      case "P":
        return "Principal";
      case "D":
        return "Dependent";
      case "B":
        return "Both (Principal/Dependent)";
      default:
        return "";
    }
  };

  // const formatToReadableDate = (dateString) => {
  //   if (!dateString) return "";

  //   const date = new Date(dateString);

  //   // Check if valid date
  //   if (isNaN(date.getTime())) return "Invalid date";

  //   // const months = [
  //   //   'Enero', 'Pebrero', 'Marso', 'Abril', 'Mayo', 'Hunyo',
  //   //   'Hulyo', 'Agosto', 'Setyembre', 'Oktubre', 'Nobyembre', 'Disyembre'
  //   // ];
  //   const months = [
  //     "January",
  //     "February",
  //     "March",
  //     "April",
  //     "May",
  //     "June",
  //     "July",
  //     "August",
  //     "September",
  //     "October",
  //     "November",
  //     "December",
  //   ];

  //   const day = date.getDate();
  //   const month = months[date.getMonth()];
  //   const year = date.getFullYear();

  //   return `${month} ${day}, ${year}`;
  // };
  // HELPER FUNCTIONS

  return (
    <div>
      {/* Header */}
      <div className="flex items-center space-x-3 mb-3">
        <FontAwesomeIcon icon={faUser} className="text-xl text-indigo-500" />
        <h2 className="text-xl font-semibold text-gray-900">Patient Details</h2>
        {/* <div className="ml-auto">
          <span className="text-xs text-gray-500">
            Transaction #: {transNo}
          </span>
        </div> */}
      </div>

      {/* Basic Information */}
      <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm">
        <h5 className="flex items-center space-x-2 text-sm font-semibold text-gray-900">
          <FontAwesomeIcon icon={faInfoCircle} className="text-indigo-500" />
          <span>Basic Information</span>

        </h5>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faUser}
                className="text-indigo-400"
                size="sm"
              />
              <span>Member Name</span>
            </label>
            <div className="flex items-center space-x-2">
              <input
                {...register("memberName")}
                className="flex-1 w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
                disabled
              />
              <button
                type="button"
                onClick={handleViewMemberInfo}
                disabled={!details?.transaction?.member_id}
                className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-indigo-600 rounded hover:bg-indigo-700 disabled:opacity-50"
              >
                <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                View Member Info
              </button>
            </div>
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="text-indigo-400"
                size="sm"
              />
              <span>Member ID</span>
            </label>
            <input
              {...register("memberID")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="flex items-center space-x-2 pt-5">
            <input
              type="checkbox"
              {...register("vip_tag")}
              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
              checked={vipChecked}
              onChange={(e) => setVipChecked(e.target.checked)}
            />
            <label className="text-xs text-gray-600">VIP Tag</label>
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faUserTie}
                className="text-indigo-400"
                size="sm"
              />
              <span>Member Type</span>
            </label>
            <input
              // {...register("memberType")}
              value={
                details?.member?.member_type
                  ? `${getMemberTypeMeaning(details?.member?.member_type)}`
                  : "-"
              }
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faBirthdayCake}
                className="text-indigo-400"
                size="sm"
              />
              <span>Birth Date</span>
            </label>
            <input
              {...register("birthDate")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faVenusMars}
                className="text-indigo-400"
                size="sm"
              />
              <span>Gender</span>
            </label>
            <input
              {...register("gender")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
        </div>
      </div>
      {/* Plan & Corporate Information */}
      <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm mt-6">
        <h5 className="flex items-center space-x-2 text-sm font-semibold text-gray-900">
          <FontAwesomeIcon icon={faBuilding} className="text-indigo-500" />
          <span>Plan & Corporate Information</span>
        </h5>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faBuilding}
                className="text-indigo-400"
                size="sm"
              />
              <span>Corporate</span>
            </label>
            <input
              {...register("corporate")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faCalendar}
                className="text-indigo-400"
                size="sm"
              />
              <span>Start Date</span>
            </label>
            <input
              {...register("startDate")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faCalendar}
                className="text-indigo-400"
                size="sm"
              />
              <span>End Date</span>
            </label>
            <input
              {...register("endDate")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faFileAlt}
                className="text-indigo-400"
                size="sm"
              />
              <span>Plan Code</span>
            </label>
            <input
              {...register("planCode")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faFileAlt}
                className="text-indigo-400"
                size="sm"
              />
              {/* <span>Plan Desc</span> */}
              <span>Plan Name</span>
            </label>
            <input
              {...register("planDesc")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faShieldAlt}
                className="text-indigo-400"
                size="sm"
              />
              <span>Plan Type</span>
            </label>
            <input
              // {...register("benefitType")}
              // value={
              //   details?.plan?.plan_type
              //     ? `${details?.plan?.plan_type} - ${getPlanTypeMeaning(
              //         details?.plan?.plan_type
              //       )}`
              //     : ""
              // }
              value={
                details?.plan?.plan_type
                  ? `${getPlanTypeMeaning(
                      details?.plan?.plan_type
                    )}`
                  : ""
              }
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faShieldAlt}
                className="text-indigo-400"
                size="sm"
              />
              <span>Benefit Type/Plan Limit Type</span>
            </label>
            <input
              // {...register("benefitType")}
              // value={
              //   details?.plan?.plan_limit_type
              //     ? `${details?.plan?.plan_limit_type} - ${getPlanLimitTypeMeaning(
              //         details?.plan?.plan_limit_type
              //       )}`
              //     : ""
              // }
              value={
                details?.plan?.plan_limit_type
                  ? `${getPlanLimitTypeMeaning(
                      details?.plan?.plan_limit_type
                    )}`
                  : ""
              }
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faUserTie}
                className="text-indigo-400"
                size="sm"
              />
              <span>Principal Name</span>
            </label>
            <div className="flex items-center space-x-2">
              <input
                {...register("principalName")}
                className="flex-1 w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
                disabled
              />
              <button
                type="button"
                onClick={handleViewPrincipalInfo}
                disabled={!details?.member?.principal_id}
                className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-indigo-600 rounded hover:bg-indigo-700 disabled:opacity-50"
              >
                <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                View Principal Info
              </button>
            </div>
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faInfoCircle}
                className="text-indigo-400"
                size="sm"
              />
              <span>Principal ID</span>
            </label>
            <input
              {...register("principalID")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
        </div>
      </div>
      {/* Benefit Limit */}
      <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm mt-6">
        <h5 className="flex items-center space-x-2 text-sm font-semibold text-gray-900">
          <FontAwesomeIcon icon={faMoneyBillWave} className="text-indigo-500" />
          <span>Benefit Limit</span>
        </h5>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>Max IP Limit</span>
            </label>
            <input
              // {...register("maxIpLimit")} // notes: remove nalang muna itong maxIpLimit sa form since di naman ginagamits
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100 inp_money"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>Remaining IP Limit</span>
            </label>
            <input
              {...register("remainingIpLimit")}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100 inp_money"
              disabled
            />
          </div>
        </div>
      </div>
      {/* Room & Board Benefit */}
      <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm mt-6">
        <h5 className="flex items-center space-x-2 text-sm font-semibold text-gray-900">
          <FontAwesomeIcon icon={faBed} className="text-indigo-500" />
          <span>Room & Board Benefit</span>
        </h5>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>Basic Limit</span>
            </label>
            <input
              // {...register("rnb_basic")}
              value={details?.benefits?.LMKIUWSQ64?.basic_limit || "0"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100 _benefits inp_money"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>Major Limit</span>
            </label>
            <input
              // {...register("rnb_major")}
              value={details?.benefits?.LMKIUWSQ64?.major_limit || "0"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100 _benefits inp_money"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faBed}
                className="text-indigo-400"
                size="sm"
              />
              <span>R&B (Category)</span>
            </label>
            {/* <input
              // {...register("rnb_category")}
              value={details?.transaction?.rnb1 || "N/A"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            /> */}
            <input
              // {...register("rnb_category")}
              value={details?.benefits?.LMKIUWSQ64?.rnb_room_type || "N/A"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>R&B Amount</span>
            </label>
            <input
              // {...register("rnb_amount")}
              value={details?.benefits?.LMKIUWSQ64?.rnb_amt || "0"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100 _benefits inp_money"
              disabled
            />
          </div>
        </div>
      </div>
      {/* CoPay */}
      <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm mt-6">
        <h5 className="flex items-center space-x-2 text-sm font-semibold text-gray-900">
          <FontAwesomeIcon icon={faShieldAlt} className="text-indigo-500" />
          <span>CoPay</span>
        </h5>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>Copay c/o Company (%)</span>
            </label>
            <input
              // {...register("copay_company")}
              value={details?.plan?.copay_corp + "%" || "0%"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>Copay c/o Member (%)</span>
            </label>
            <input
              // {...register("copay_member")}
              value={details?.plan?.copay_member  + "%" || "0%"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
        </div>
      </div>
      {/* Anesthesiologist Benefit Details */}
      <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm mt-6">
        <h5 className="flex items-center space-x-2 text-sm font-semibold text-gray-900">
          <FontAwesomeIcon icon={faStethoscope} className="text-indigo-500" />
          <span>Anesthesiologist Benefit Details</span>
        </h5>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faStethoscope}
                className="text-indigo-400"
                size="sm"
              />
              <span>Basic Benefit</span>
            </label>
            <input
              // {...register("sob_anes_basic")}
              // value={details?.benefits?.WXLZFNRUBH?.basic_limit || "0"}
              // "anes_basic_rate_x":"50%","anes_major_rate_x":null
              value={details?.plan?.anes_basic_rate + "%" || "0%"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faStethoscope}
                className="text-indigo-400"
                size="sm"
              />
              <span>Major Benefit</span>
            </label>
            <input
              // {...register("sob_anes_major")}
              // value={details?.benefits?.WXLZFNRUBH?.major_limit || "0"}
              // "anes_basic_rate_x":"50%","anes_major_rate_x":null
              value={details?.plan?.anes_major_rate + "%" || "0%"}
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
          <div className="space-y-1">
            <label className="flex items-center space-x-1 text-xs text-gray-600">
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-indigo-400"
                size="sm"
              />
              <span>Provider IP PF Rate(%)</span>
            </label>
            <input
              // {...register("ip_anes_rate")}
              value={
                details?.provider_prof_fees[0]?.ip_rate_anes_x + "%" || "0%"
              }
              className="w-full rounded-md border border-gray-300 px-3 py-1 text-sm disabled:bg-gray-100"
              disabled
            />
          </div>
        </div>
      </div>
      {/* Final Diagnosis */}
      <div className="space-y-2 mt-6">
        {/* <label className="flex items-center space-x-2 text-sm font-medium text-gray-700">
          <FontAwesomeIcon icon={faInfoCircle} className="text-indigo-500" />
          <span>Final Diagnosis</span>
        </label>
        <textarea
          {...register("final_diagnosis")}
          rows={3}
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          // placeholder="Enter final diagnosis..."
          disabled
        /> */}
        
        {/* {errors.final_diagnosis && (
          <p className="text-xs text-red-500">
            {errors.final_diagnosis.message}
          </p>
        )} */}
      </div>


      {/* External Modals */}
      {isViewMemberModalOpen && (
        <MemberViewModal
          memberId={selectedMemberId}
          onClose={() => setIsViewMemberModalOpen(false)}
        />
      )}

      
    </div>
  );
};

export default PatientDetailsTab;
